const TITLE = "◼ فرم عضویت بنیاد بین‌المللی صلوات";

export default function Head() {
  return (
    <>
      <div className="w-full text-center md:text-right px-4 grid grid-cols-1 md:grid-cols-2 items-center justify-between">
        <span className="hidden md:inline-block md:text-2xl">{TITLE}</span>
        <img
          className="h-32 mx-auto md:mr-auto md:ml-0"
          src="salavat_logo.png"
          alt=":)"
        />
        <span className="inline-block md:hidden md:text-2xl">{TITLE}</span>
      </div>
      <div className="divider !m-0 !p-0"></div>
    </>
  );
}
